var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightarrowpagination(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M7.487 7.58929C7.61698 7.70439 7.74696 7.8195 7.87694 7.9346L1.29123 13.7666C0.944616 14.0735 0.598002 14.3805 0.251385 14.6874C-0.528501 15.378 0.684656 16.4907 1.46454 15.7617C3.93418 13.6131 6.31717 11.5029 8.70016 9.39259C9.04677 9.08564 9.39339 8.7787 9.74001 8.47175C10.0867 8.16481 10.0867 7.66602 9.74001 7.39745L2.63437 1.10508L1.63785 0.222613C0.857964 -0.468013 -0.398521 0.606295 0.424692 1.29692C2.76435 3.3688 5.14734 5.47904 7.487 7.58929Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrowpagination);
export default __webpack_public_path__ + "static/media/right arrow pagination.934d7d38d1ad3d09f0c4a7bb4148a182.svg";
export { ForwardRef as ReactComponent };